/**
 * BoxContainer parser: the shared base (Control and `alignment`) plus `vertical`,
 * which this class serialises and its fixed-axis subclasses do not.
 */
import { parseOptionalBool } from '../../../../parser/valueParsers';
import { parseBoxContainer as parseSharedBoxContainer } from '../shared/boxContainer';
export function parseBoxContainer(heading, properties) {
    const result = { ...parseSharedBoxContainer(heading, properties) };
    result.vertical = parseOptionalBool(properties.vertical);
    return result;
}
//# sourceMappingURL=parser.js.map